import React, { Component } from 'react'
import { connect } from 'react-redux'
import setActiveCurrency from '../../actions/setActiveCurrency'

// GA events handler
import triggerCustomGaEvent from '../../utilities/analytics/triggerCustomGaEvent'

import BkFlowCurrencyToggleDefault from './layouts/BkFlowCurrencyToggleDefault'
import BkFlowCurrencyToggleIconMenu from './layouts/BkFlowCurrencyToggleIconMenu'

class BkFlowCurrencyToggle extends Component {

	constructor(props) {
		super(props)
		this.state = {
			currencyMenuVisible: false
		}
	}

	handleToggleCurrencyMenu = () => {
		this.setState({
			currencyMenuVisible: !this.state.currencyMenuVisible
		})
	}

	handleSelectCurrency = (currency) => {
		const { handleSetActiveCurrency } = this.props
		const stayParameters = new URLSearchParams(window.location.search)

		this.setState({
			currentLanguage: currency
		})

		if (stayParameters.has('currency')) {
			stayParameters.set('currency', currency)
		}

    window.location.search = stayParameters.toString();

		handleSetActiveCurrency(currency)

		triggerCustomGaEvent('analytics-updateCurrency', currency)
	}

	render() {
		const {
			configData,
			isMobile,
			displayLabel,
			activeCurrencyData
		} = this.props

		const hotelComponents = configData.hotel.options.components,
					hotelLabels = configData.hotel.labels[0],
					supportedCurrencies = hotelComponents.supportedCurrencies

		let currencyOptions = []

		if ( supportedCurrencies ) {
			for (let currency in supportedCurrencies) {
				if (process.env.REACT_APP_COMPONENT_NAVIGATION_CURRENCY_TOGGLE_LAYOUT === 'icon-menu') {
					currencyOptions.push(
						<button
							key={ supportedCurrencies[currency] }
							className="btn btn-primary"
							onClick={() => this.handleSelectCurrency(supportedCurrencies[currency])}
						>
							{supportedCurrencies[currency]}
						</button>
					)
				} else {
					currencyOptions.push(
						<option
							key={ supportedCurrencies[currency] }
							value={ supportedCurrencies[currency] }
						>
							{ supportedCurrencies[currency] }
						</option>
					)
				}
			}
		}

		return (
			 process.env.REACT_APP_COMPONENT_NAVIGATION_CURRENCY_TOGGLE_LAYOUT === 'icon-menu' ? (
				 <BkFlowCurrencyToggleIconMenu
					 currencyData={activeCurrencyData}
					 currencyOptions={currencyOptions}
					 currencyEvent={(e) => this.handleSelectCurrency(e)}
					 displayLabel={false}
					 hotelLabels={hotelLabels}
					 isMobile={isMobile}
					 currencyMenuEvent={this.handleToggleCurrencyMenu}
					 currencyMenuVisible={this.state.currencyMenuVisible}
				 />
			 ) : (
				 <BkFlowCurrencyToggleDefault
					 currencyData={activeCurrencyData}
					 currencyOptions={currencyOptions}
					 currencyEvent={(e) => this.handleSelectCurrency(e)}
					 displayLabel={displayLabel}
					 hotelLabels={hotelLabels}
					 isMobile={isMobile}
				 />
			 )
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		activeCurrencyData: state.activeCurrencyData
	}
}

const mapDispatchToProps = dispatch => ({
	handleSetActiveCurrency(activeCurrency) {
		dispatch(setActiveCurrency(activeCurrency))
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(BkFlowCurrencyToggle)


// WEBPACK FOOTER //
// ./src/components/currency/BkFlowCurrencyToggle.js